import { Routes } from './Routes';
export function isSecureRoute(path: string) {
  return (current: string) => {
    return Object.values(Routes).some((item) => {
      if (!('secured' in item)) return false;
      return item.secured && item.route.isMatch(current);
    });
  };
}
